<template>
  <section role="side-modal">
      <transition name="fade" mode="out-in">
          <div id="overlay" v-show="aberto" @click="fecha(id)"></div>
      </transition>
      <div class="side" :id="id">
          <div class="side-content">
              <div class="side-header">
                  <div class="side-close" aria-label="Close" @click="fecha(id)">
                      <div class="side-close-circle">
                          <div class="side-close-x">
                              <div class="side-close-x1"></div>
                              <div class="side-close-x2"></div>
                          </div>
                      </div>
                  </div>
                  <div class="side-title" :id="`${id}-label`">{{ tit }}</div>
              </div>
              <div class="side-subtitle" :id="`${id}-sublabel`">{{ subtit }}
                  <p>{{ subtDetl }}</p>
              </div>
              <!-- Slot para inserir 'side-body' e 'side-footer' do modal -->
              <slot></slot>
          </div>
      </div>
  </section>
</template>

<script>
import Botao from '@/components/botao'

export default {
  name: 'SideModal',

  props: {
    tit: {
      required: true,
      type: String,
      value: ''
    },
    subtit: {
      required: false,
      type: String,
      value: ''
    },
    subtDetl: {
      required: false,
      type: String,
      value: ''
    },
    larg: {
      required: false,
      type: Number,
      value: 600
    },
    id: {
      required: true,
      type: String,
      value: ''
    },
    abreMaisUm: {
      required: false,
      type: Boolean,
      value: false
    },
    aberto: {
      required: true,
      type: Boolean,
      value: false
    }
  },
  methods: {
    largString (larg) {
      return larg + 'px'
    },
    largCalc (larg) {
    // soma para esconder o box-shadow
    const calc = larg + 30
    return '-' + calc + 'px'
    },
    abre (id) {
      document.querySelector('#' + id).style.right = '0px'
    },
    abreOutro () {
      this.$emit('abreFromChild')
    },
    fecha (id) {
      document.querySelector('#' + id).style.width = this.largString (this.larg)
      document.querySelector('#' + id).style.right = this.largCalc (this.larg)
      this.$emit('fechou')
    },
    fechaFromParent (id, larg) {
      document.querySelector('#' + id).style.right = this.largCalc (larg)
    },
    expande (id, larg) {
      document.querySelector('#' + id).style.width = this.largString (larg)
      this.abre(id)
    },
    contrai (id, larg) {
      document.querySelector('#' + id).style.width = this.largString (larg)
      this.$emit ('largura', larg)
    }
  },
  components: {
    botao: Botao
  },
  created () {
	  this.$parent.$on('mostra', id => this.abre(id))
	  this.$parent.$on('esconde', prop => this.fechaFromParent(prop.identidade, prop.largura))
	  this.$parent.$on('mostraMais', prop => this.expande(prop.id, prop.larg))
	  this.$parent.$on('escondeMais', prop => this.contrai(prop.identidade, prop.largura))
  },
  mounted () {
    document.querySelector('#' + this.id).style.width = this.largString (this.larg)
    document.querySelector('#' + this.id).style.right = this.largCalc (this.larg)
  }
}
</script>

<style scoped>
.side {
  height: 100vh;
  width: 600px;
  position: fixed;
  z-index: 2000;
  top: 0px;
  right: -625px;
  background-color: #ffffff;
  overflow-x: hidden; /* Disable horizontal scroll */
  box-shadow: 5px 2px 28px 0px rgba(0,0,0,0.55);
  transition: 0.5s;
}
.side-header {
    display: flex;
}
.side-content {
    padding: 15px;
}
.side-title {
    display: inline-block;
    color: #cccccc;
    font-weight: 800;
    font-size: 5rem;
    letter-spacing: -0.3rem;
    text-transform: uppercase;
}
.side-subtitle {
    margin: 0px 42px 15px;
    font-size: 3.2rem;
    font-weight: bold;
    letter-spacing: -0.1rem;
}
.side-subtitle p {
    color: #888888;
    font-size: 2.2rem;
    font-weight: normal;
    letter-spacing: 0rem;
}
.side-close {
    display: flex;
    align-items: center;
    margin-right: 12px;
}
.side-close-circle {
    background: transparent;
    height: 27px;
    width: 27px;
    border: 3px solid #fabbc8;
    border-radius: 100%;
    cursor: pointer;
    display: flex;
}
.side-close-x {
    display: inline-block;
    transform: translate(3.5px, 8px)
}
.side-close-x1 {
    background-color: firebrick;
    width: 13px;
    height: 3px;
    transform: rotate(45deg) translate(1px, 0px);
}
.side-close-x2 {
    background-color: firebrick;
    width: 13px;
    height: 3px;
    transform: rotate(-45deg) translate(2px, -1px)
}
.side-body {
    border-bottom: 1px solid #e8f0dd;
    padding: 10px 0px 15px;
    margin: 15px 42px;
}
.side-footer {
    margin: 25px 42px;
}
#overlay {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    background: rgba(0,0,0,0.25);
    z-index: 2000;
}

@media screen and (max-width: 425px) {
  .side-header {
      display: block;
  }
  .side-content {
      padding: 0 0 15px 0;
  }
  .side-title {
      margin-left: 15px;
  }
  .side-subtitle {
      margin: 0px 15px 15px;
  }
  .side-close {
      /* display: flex;
      align-items: center; */
      margin: 0 0 -10px;
  }
  .side-close-circle {
      background: #fbdae0;
      border: 3px solid #fbdae0;
      border-radius: 0 0 10px 0;
  }
  .side-body {
      margin: 15px;
  }
  .side-footer {
      margin: 25px 15px;
  }
}

@media screen and (max-width: 405px) {
  .side-footer {
      margin: 25px 0;
  }
}
</style>



// WEBPACK FOOTER //
// side-modal.vue?5dc77443